export default __webpack_public_path__ + "static/fire-emblem-tactics-ee137baae44614cbcdd568073580eb47.png";